import React from "react";
import MaintenancePage from "../../Pages/maintainnance/MaintenancePage";

const Srm = () => {
  return (
    <>
      <MaintenancePage />
    </>
  );
};

export default Srm;
